import { ChannelType, isPlugChannelType } from "../../../src/models/ChannelType";
import { C1_EloItem_Type, type C1_EloItem_Definition, type C1_EloItem_Details } from "../types/C1_EloTypes";

/** Returns the ESTADA consumer channel matching one atomic ELO definition. */
export function channelTypeForDefinition(definition: Pick<C1_EloItem_Definition, "type" | "defaultDetails">, instanceData: {details?: C1_EloItem_Details}): ChannelType {
  const configuredChannelType = instanceData.details?.channelType ?? definition.defaultDetails?.channelType;
  const plugType = instanceData.details?.plugType ?? definition.defaultDetails?.plugType;
  // Outlet edits carry the previous consumer channel in their projected details.
  // The selected outlet type must take precedence over that stale value.
  if (definition.type !== C1_EloItem_Type.Plug && configuredChannelType !== undefined) return configuredChannelType;
  switch (definition.type) {
    case C1_EloItem_Type.IntermediateDistribution:
      return ChannelType.IntermediateDistribution;
    case C1_EloItem_Type.DoorLock:
      return ChannelType.DoorLock;
    case C1_EloItem_Type.Camera:
      return ChannelType.Camera;
    case C1_EloItem_Type.Light:
      return instanceData.details?.channelType ?? definition.defaultDetails?.channelType ?? ChannelType.Switch;
    case C1_EloItem_Type.Blind:
      return ChannelType.Blind;
    case C1_EloItem_Type.Jalousie:
      return ChannelType.Jalousie;
    case C1_EloItem_Type.Heating:
    case C1_EloItem_Type.Thermostat:
      return ChannelType.Heating;
    case C1_EloItem_Type.Plug:
      return isPlugChannelType(plugType) ? plugType
        : isPlugChannelType(configuredChannelType) ? configuredChannelType : ChannelType.plug_230V;
    case C1_EloItem_Type.FixedPower:
      return instanceData.details?.voltage === "400V" ? ChannelType.suply400V : ChannelType.suply230V;
    default:
      return ChannelType.Switch;
  }
}

